module.exports = __webpack_public_path__ + "static/media/logo.3c6f470c.svg";